/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-07-18 12:25:48
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2021-07-26 09:31:14
 */
const routerList = [
    {
        path: "/mch-center/mch-overview",
        name: "商户概览",
        component: () => import("@/views/mch-center/mch-overview/mch-overview.vue"),
    },
    {
        path: "/mch-center/merchant-manage",
        name: "商户管理",
        component: () => import("@/views/mch-center/merchant-manage/merchant-manage.vue"),
        children: [
            {
                path: "/mch-center/merchant-manage/edit-merchant",
                name: "编辑商户",
                component: () => import("@/views/mch-center/merchant-manage/children/edit-merchant/edit-merchant.vue"),
                meta: {
                    nameKey: "merchantUp",
                    footerBg: true,
                },
            },
            {
                path: "/mch-center/merchant-manage/add-merchant",
                name: "新增商户",
                component: () => import("@/views/mch-center/merchant-manage/children/add-merchant/add-merchant.vue"),
                meta: {
                    nameKey: "merchantAdd",
                    footerBg: true,
                },
            },
            {
                path: "/mch-center/merchant-manage/merchant-detail",
                name: "商户详情",
                component: () => import("@/views/mch-center/merchant-manage/children/details-merchant/details-merchant.vue"),
                meta: {
                    nameKey: "merchantDetails",
                },
            },
            {
                path: "/mch-center/merchant-manage/operation-log",
                name: "商户日志",
                component: () => import("@/views/mch-center/merchant-manage/children/mch-operation-log/mch-operation-log.vue"),
                meta: {
                    nameKey: "mchOperationLog",
                },
            },
        ],
    },
    {
        path: "/mch-center/finance-bill/merchant-bill",
        name: "商户账单",
        component: () => import("@/views/mch-center/finance-bill/merchant-bill/merchant-bill.vue"),
    },
    {
        path: "/mch-center/finance-bill/pile-bill",
        name: "电桩账单",
        component: () => import("@/views/mch-center/finance-bill/pile-bill/pile-bill.vue"),
    },
    {
        path: "/mch-center/finance-bill/site-bill",
        name: "电站账单",
        component: () => import("@/views/mch-center/finance-bill/site-bill/site-bill.vue"),
    },
    {
        path: "/mch-center/finance-bill/ent-bill",
        name: "团体客户账单",
        component: () => import("@/views/mch-center/finance-bill/ent-bill/ent-bill.vue"),
    },
    {
        path: "/mch-center/finance-bill/card-bill",
        name: "充电卡账单",
        component: () => import("@/views/mch-center/finance-bill/card-bill/card-bill.vue"),
    },
    {
        path: "/mch-center/finance-bill/finance-statistics",
        name: "财务统计",
        component: () => import("@/views/mch-center/finance-bill/finance-statistics/finance-statistics.vue"),
    },
    {
        path: "/mch-center/finance-checking/operation-checking",
        name: "运营核算",
        component: () => import("@/views/mch-center/finance-checking/operation-checking/operation-checking.vue"),
    },
    {
        path: "/mch-center/finance-checking/recharge-checking",
        name: "充值核算",
        component: () => import("@/views/mch-center/finance-checking/recharge-checking/recharge-checking.vue"),
    },
    {
        path: "/mch-center/finance-checking/recharge-checking/correct",
        name: "修正充值核算",
        component: () => import("@/views/mch-center/finance-checking/recharge-checking/children/recharge-checking-correct/recharge-checking-correct.vue"),
        meta: {
            nameKey: "rechargeCheckingCorrect",
        },
    },
    {
        path: "/mch-center/finance-checking/refund-checking",
        name: "退款核算",
        component: () => import("@/views/mch-center/finance-checking/refund-checking/refund-checking.vue"),
    },
    {
        path: "/mch-center/finance-checking/refund-checking/correct",
        name: "退款充值核算",
        component: () => import("@/views/mch-center/finance-checking/refund-checking/children/refund-checking-correct/refund-checking-correct.vue"),
        meta: {
            nameKey: "refundCheckingCorrect",
        },
    },
    {
        path: "/mch-center/finance-checking/site-checking",
        name: "站点核算",
        component: () => import("@/views/mch-center/finance-checking/site-checking/site-checking.vue"),
    },
    {
        path: "/mch-center/finance-checking/user-checking",
        name: "用户核算",
        component: () => import("@/views/mch-center/finance-checking/user-checking/user-checking.vue"),
    },
    {
        path: "/mch-center/merchant-sharing",
        name: "商户分成",
        component: () => import("@/views/mch-center/merchant-sharing/merchant-sharing.vue"),
        children: [
            {
                path: "/mch-center/merchant-sharing/error-info",
                name: "分成结算异常信息",
                component: () => import("@/views/mch-center/merchant-sharing/children/error-info/error-info.vue"),
                meta: {
                    nameKey: "merchantSharingErrorInfo",
                },
            },
        ],
    },
    {
        path: "/mch-center/mch-withdrawal",
        name: "商户提现",
        component: () => import("@/views/mch-center/mch-withdrawal/mch-withdrawal.vue"),
        children: [
            {
                path: "/mch-center/mch-withdrawal/add",
                name: "新增提现单",
                component: () => import("@/views/mch-center/mch-withdrawal/children/add-withdrawal/add-withdrawal.vue"),
                meta: {
                    nameKey: "addWithdrawal",
                },
            },
            {
                path: "/mch-center/mch-withdrawal/template",
                name: "提现单模板",
                component: () => import("@/views/mch-center/mch-withdrawal/children/cash-template/cash-template.vue"),
                meta: {
                    nameKey: "withdrawalTpl",
                },
            },
            {
                path: "/mch-center/mch-withdrawal/details",
                name: "提现单详情",
                component: () => import("@/views/mch-center/mch-withdrawal/children/details-withdrawal/details-withdrawal.vue"),
                meta: {
                    nameKey: "detailsWithdrawal",
                },
            },
        ],
    },
    {
        path: "/mch-center/recharge-manage",
        name: "充值管理",
        component: () => import("@/views/mch-center/recharge-manage/recharge-manage.vue"),
        children: [
            {
                path: "/mch-center/recharge-manage/recharge-manage-details",
                name: "充值详情",
                component: () => import("@/views/mch-center/recharge-manage/children/recharge-manage-details/recharge-manage-details.vue"),
                meta: {
                    nameKey: "memberRechargeDetails",
                },
            },
        ],
    },
    {
        path: "/mch-center/refund-manage",
        name: "退款管理",
        component: () => import("@/views/mch-center/refund-manage/refund-manage.vue"),
        children: [
            {
                path: "/mch-center/refund-manage/details",
                name: "退款管理",
                component: () => import("@/views/mch-center/refund-manage/children/records-details/records-details.vue"),
                meta: {
                    nameKey: "refundRecordsDetails",
                },
            },
            {
                path: "/mch-center/refund-manage/audit",
                name: "退款管理",
                component: () => import("@/views/mch-center/refund-manage/children/records-audit/records-audit.vue"),
                meta: {
                    nameKey: "refundRecordsAudit",
                },
            },
        ],
    },
    {
        path: "/mch-center/invoice-manage",
        name: "发票管理",
        component: () => import("@/views/mch-center/invoice-manage/invoice-manage.vue"),
        children: [
            {
                path: "/mch-center/invoice-manage/details",
                name: "发票详情",
                component: () => import("@/views/mch-center/invoice-manage/chileren/invoice-details/invoice-details.vue"),
                meta: {
                    nameKey: "invoiceDetails",
                },
            },
            {
                path: "/mch-center/invoice-manage/audit",
                name: "发票审核",
                component: () => import("@/views/mch-center/invoice-manage/chileren/invoice-audit/invoice-audit.vue"),
                meta: {
                    nameKey: "invoiceAudit",
                    footerBg: true,
                },
            },
        ],
    },
    {
        path: "/mch-center/invoice-config",
        name: "发票配置",
        component: () => import("@/views/mch-center/invoice-config/invoice-config.vue"),
    },
];
export default routerList;
